import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Search param: předvyplnění filtru čísla faktury (proklik z globálního
 * vyhledávání v horní liště). Neplatné hodnoty tiše zahodíme.
 */
const fakturySearchSchema = z.object({
  cislo: z.string().max(50).optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/faktury")({
  validateSearch: (search) => fakturySearchSchema.parse(search),
  beforeLoad: requirePermissionGuard("hca.faktury.read"),
});
